export default __webpack_public_path__ + "static/media/banner-loja-profissional.6ff8fdba.jpg";